import React, { useEffect, useRef, useState } from "react";
import { Column, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCabecera } from "../../../Componentes/Basicos/LVGridCabecera";
import { PaginaReporte } from "../../../Componentes/Compuestos/Paginas/PaginaReporte";
import { function_VEN_Pedidos_Cabecera_ListarClientesSinPedidoPorTiempo } from "neftis7_apicaller/src/funciones/VEN/Pedidos/VEN_Pedidos_Cabecera";

export const VEN_Reporte_Pedidos_ClientesSinPedidoPorTiempo = () => {
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)
  const refRecargaListado = useRef(null);

  const handleDataLoaded = (data) => {
    setData(data);
  };

  const getData = async () => {
    try {
      console.log(localStorage.getItem("CodigoCompania"))
      let resultData = await function_VEN_Pedidos_Cabecera_ListarClientesSinPedidoPorTiempo();

      setData(resultData.data)

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    getData();
  }, []);


  return (
    <PaginaReporte
      Titulo="CLIENTES SIN REALIZAR PEDIDOS"
      onDataLoaded={handleDataLoaded}
    >
      {loading && (
        <div className="spinner-overlay">
          <div className="card-body text-center">
            <div className="spinner-border" role="status">
              <span className="sr-only">Cargando...</span>
            </div>
          </div>
        </div>
      )}
      <div className="table-responsive">
        <div style={{ display: 'flex', alignItems: 'left', marginTop: '10px', marginBottom: '10px', gap: '20px' }}>

        </div>
        {data.length > 0 ? (
          <LVGridCabecera
            dataSource={data}
            PageSize={13}
            id="gridContainer"
            keyExpr="IdPedido"
          >
            <Summary>
              <TotalItem
                column="IdPedido"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`} />
              <TotalItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency" />
              <TotalItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency" />
              <TotalItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number" />

              <GroupItem
                column="IdPedido"
                summaryType="count"
                customizeText={summaryItem => `Registros: ${summaryItem.value}`}
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteNeto"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteIVA"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteBonificaciones"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteRecargos"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="ImporteTotal"
                summaryType="sum"
                customizeText={summaryItem => `$ ${summaryItem.value.toFixed(1).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="currency"
                displayFormat="currency"
                showInGroupFooter={true} />
              <GroupItem
                column="Peso"
                summaryType="sum"
                customizeText={summaryItem => `${summaryItem.value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`}
                valueFormat="number"
                showInGroupFooter={true} />
            </Summary>

            <Column caption="Ultimo Pedido" alignment="Center">
              <Column caption="Código" dataField="IdPedido" width="120" alignment="Right" dataType="number" />
              <Column caption="Fecha" dataField="FechaUltimoPedido" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
            </Column>
            <Column caption="Código" dataField="IdCliente" width="200" alignment="Right" dataType="number" />
            <Column caption="Cliente" dataField="RazonSocial" width="100%" minWidth={150} alignment="Left" dataType="string" />
            <Column caption="Días desde último Pedido" dataField="DiasSinPedido" width="200" alignment="Right" dataType="number" />
            <Column caption="Importe Total" dataField="ImporteTotal" width="150" alignment="Right" dataType="number" format="currency" />

          </LVGridCabecera>
        ) : (
          <div className="card-body text-center">
            <h5 className="card-title">No hay datos</h5>
          </div>
        )}
      </div>
    </PaginaReporte>
  );
};
